import {FuseLoadable} from '@fuse';

export const RPImplementationDashboardConfig  = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/rpimplementation/Dashboard',
            component: FuseLoadable({
                loader: () => import('../../dashboards/analytics/AnalyticsDashboardApp')
              
            })
        },
      
       
      

    ]
};

